import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User viewed notification preferences page',
  name: 'viewed_notification_preferences_page',
};

export default META;
